import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { BaseComponent } from '@m4u-angular/base/component/BaseComponent';
import { ServiceBagService, ServiceBagServices } from '@m4u-angular/base/component/ServiceBag';
import { BaseState } from '@m4u-angular/base/entities/BaseEntities';
import { EnumLanguages } from '@m4u-angular/core/framework/sysenums.enum';
import { SysGlobals } from '@m4u-angular/core/framework/sysglobals';
import { Utils } from '@m4u-angular/core/helpers/Utils';
import { PdfJsViewerComponent } from 'ng2-pdfjs-viewer';
import { LanguageService } from '../../../core/framework/language.service';

class State extends BaseState {
    PDFData: Blob;
    ShowLoadPanel: boolean;
}

@Component({
    providers: ServiceBagServices,
    selector: 'm4u-pdf-viewer',
    templateUrl: './pdf-viewer.component.html',
    styleUrls: ['./pdf-viewer.component.scss']
})
export class PdfViewerComponent extends BaseComponent<State> {

    @Input() FileName: string;
    @Input() set PDFData(value: string | Blob) { 
        if(typeof value === 'string') value = Utils.ConvertToBlob(value, 'application/pdf'); 
        this.State.PDFData = value;
        if (this.State.PDFData) {
            this.State.ShowLoadPanel = false;
            this.SetStyles();
        }
    }
    @Output() OnDocumentLoaded = new EventEmitter<any>();

    @ViewChild(PdfJsViewerComponent) instance: PdfJsViewerComponent;

    constructor(A: ServiceBagService, private languageService: LanguageService) {
        super(A, 'PdfViewerComponent', State);
    }

    protected override OnInitComponent(): void {
        setTimeout(() => !this.State.PDFData && (this.State.ShowLoadPanel = false), 3000);
    }

    protected OnInitComponentFinished(): void {
        this.SetStyles();
    }

    protected override OnInitState() {
        this.State.ShowLoadPanel = !this.State.PDFData;
    }

    GetLocale(): string {
        return this.languageService.GetLanguage();
    }

    DocumentLoaded(event: any) {
        this.OnDocumentLoaded.emit(event);
    }

    private SetStyles() {
        setTimeout(() => {
            const iframeDocument = this.instance?.iframe?.nativeElement?.contentDocument;
            if (!iframeDocument) return;

            const style = iframeDocument.createElement('style');

            const toolbarStyles = `
                #toolbarContainer {
                    background: #294D92;
                }
            `;
            const backgroundStyles = `
                #viewerContainer {
                    background-color: white;
                }
            `;

            style.appendChild(iframeDocument.createTextNode(toolbarStyles));
            if (this.A.Screen.IsMobile()) style.appendChild(iframeDocument.createTextNode(backgroundStyles));

            iframeDocument.head && iframeDocument.head.appendChild(style);
        }, 500);
    }
}
